module.exports = __webpack_public_path__ + "dancepartywp4c7ccb78b92185cf75ace92a3541adf2.png";